export default __webpack_public_path__ + "static/media/canvas-green.c8bc81f4.webp";